"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatErrorMessage = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
require("./ChatErrorMessage.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ChatErrorMessage = function ChatErrorMessage(_ref) {
  var message = _ref.message,
    callback = _ref.callback,
    actionText = _ref.actionText;
  if (callback) {
    return /*#__PURE__*/_react.default.createElement(_row.default, {
      align: "middle",
      className: "chat-error-container",
      justify: "center",
      type: "flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "chat-error-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "chat-error-message"
    }, message), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: callback
    }, actionText))));
  }
  return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, {
    size: "large",
    tip: message
  });
};
exports.ChatErrorMessage = ChatErrorMessage;